// extracted by mini-css-extract-plugin
export default {"container":"reward_container__EfdzA","thumb":"reward_thumb__Fgr+c","set":"reward_set__1LdLl"};